import { render } from "./v-profile-link.vue?vue&type=template&id=cf43681e&scoped=true"
import script from "./v-profile-link.vue?vue&type=script&lang=js"
export * from "./v-profile-link.vue?vue&type=script&lang=js"

import "./v-profile-link.vue?vue&type=style&index=0&id=cf43681e&scoped=true&lang=css"

import exportComponent from "D:\\projects\\vue\\e-justice-sud-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf43681e"]])

export default __exports__